import React, { useEffect, useState } from "react";
import { Card, Form, Button, message, Typography, InputNumber } from "antd";
import axios from "axios";
import "./Setting.scss";

const { Title } = Typography;

function Setting() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchList();
  }, []);

  const fetchList = () => {
    axios
      .get(`${process.env.REACT_APP_ADMIN_API_URL}setting`, {
        headers: {
          "x-product-type": "PIP_GRID",
        },
      })
      .then((res) => {
        const commission = res?.data?.data?.referralCommissionPercentage || 0;
        form.setFieldsValue({
          referralCommissionPercentage: commission,
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const onFinish = (values) => {
    let payload = {
      referralCommissionPercentageee: values?.referralCommissionPercentage,
    };
    setLoading(true);
    axios
      .put(`${process.env.REACT_APP_ADMIN_API_URL}setting/update`, payload, {
        headers: { "x-product-type": "PIP_GRID" },
      })
      .then(() => {
        message.success("Referral commission updated successfully!");
        setLoading(false);
        fetchList();
      })
      .catch((err) => {
        console.log("🚀 ~ onFinish ~ err:+++++++++++++", err?.message)
        message.error(err?.response.message || err?.message  || "Something went wrong");
        setLoading(false);
      });
  };

  return (
    <div className="settings-page">
      <div className="settings-header">
        <Title level={3} className="page-title">
          Settings
        </Title>
      </div>
      <Card className="settings-card">
        <Form form={form} layout="vertical" onFinish={onFinish} autoComplete="off" initialValues={{ referralCommissionPercentage: 0 }}>
          <Form.Item
            label="Referral Commission Percentage"
            name="referralCommissionPercentage"
            rules={[
              { required: true, message: "Please enter referral commission percentage!" },
              {
                type: "text",
                message: "Percentage must be between 0 and 100",
              },
            ]}
          >
            <InputNumber
              min={0}
              max={100}
              formatter={(value) => `${value}`}
              parser={(value) => value.replace("%", "")}
              style={{ width: "100%" }}
              size="large"
              placeholder="Enter commission percentage"
              className="custom-input"
            />
          </Form.Item>
          <Form.Item className="form-actions">
            <Button type="primary" htmlType="submit" loading={loading} size="large" className="submit-btn">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
export default Setting;